import React, { Component } from 'react';
import $ from 'jquery';
import { getCookie, setCookie, setSearchCookie } from './Common';
import { useNavigate } from 'react-router-dom';
class SecSearch extends Component {

  constructor(props) {
    super(props);
    const stored = getCookie('searchHistory') || [];
    this.state = {
      keyword: '',
      loading: true,
      error: null,
      autoSave: getCookie('pocketAuto')
    };
  }

  componentDidMount() {
    const mainSearchInput = $('#main-input-search');

    //word가 아닌 box 영역을 클릭한 경우 이벤트 : input에 focus
    $('#main-search .input-wrap').on('click', function () {
      $('#main-search .rolling').hide();
      mainSearchInput.focus();
    });

    // input에서 focus잃을 경우 : rolling 다시 시작 / input에 텍스트가 입력된 경우는 input show 유지
    mainSearchInput.blur(function () {
      if (mainSearchInput.val().trim().length > 0) {
        $('#main-search .rolling').hide();
      } else {
        $('#main-search .rolling').show();
      }
    });



    const tabLinks = document.querySelectorAll('.search-sort .tab-link');
    const tabContent = document.querySelector('.sort-list');

    // 각 탭에 해당하는 버튼 내용
    const tabData = {
      'sort-1': ['ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ', 'ㄲ', 'ㄸ', 'ㅃ', 'ㅆ', 'ㅉ'],
      'sort-2': [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'], // A~Z
      'sort-3': [...'0123456789'], // 0~9
    };

    // 탭 클릭 이벤트 추가
    tabLinks.forEach((tab) => {
      tab.addEventListener('click', function () {
        const selectedTab = this.getAttribute('data-tab');

        tabLinks.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');

        updateSortList(tabData[selectedTab]);
      });
    });

    // sort-list 내용 업데이트 함수
    function updateSortList(items) {
      //tabContent.innerHTML = items.map((item) => `<li><button className="btn" title="${item}" type="button" onClick={() => this.handleClick("${item}")}>${item}</button></li>`).join('');
      tabContent.innerHTML = items
        .map(item => `<li><button class="btn" data-item="${item}" type="button" title="${item}">${item}</button></li>`)
        .join('');
    }
    tabContent.addEventListener('click', (e) => {
      if (e.target.tagName === 'BUTTON') {
        const item = e.target.getAttribute('data-item');
        this.handleWordClick(item);
      }
    });
  }

  handleWordClick = (char) => {
    window.scrollTo(0, 0);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.props.navigate(`/WordList/${encodeURIComponent(char)}`);
      });
    });
  };

  handleChange = (e) => {
    this.setState({ keyword: e.target.value });
  }

  handleClick = (e) => {
    e.preventDefault(); // a 태그의 기본 동작 막기

    const { keyword } = this.state;

    const trimmedKeyword = keyword.trim(); // 앞뒤 공백 제거

    if (!trimmedKeyword || trimmedKeyword == '') {
      alert("검색어를 입력해주세요.");
      return; // 아무 것도 하지 않음
    }
    const pocketAuto = getCookie('pocketAuto');
    if (pocketAuto === 'on') {
      this.addSearchHistory(keyword);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.props.navigate(`/Search/${encodeURIComponent(keyword)}`);
  }

  addSearchHistory = (keyword) => {
    if (this.state.autoSave == 'on') {
      this.setState((prevState) => {
        const updated = [keyword, ...prevState.searchHistory.filter(k => k !== keyword)].slice(0, 10);
        setSearchCookie('searchHistory', updated, { path: '/' });
        return { searchHistory: updated };
      });
    }
  };
  
  render() {
    return (
      <section className="section">
        <div className="container">
          <div className="main-search" id="main-search">
            <span className="main-search__toggle"> 궁금한 용어를 검색해 보세요! </span>
            <form className="main-search__form" method="post" autoComplete="off">
              <button type="sumbit" className="main-search__btn" title="검색" onClick={this.handleClick}> </button>

              <div className="input-wrap">
                <input type="search" className="search-input" id="main-input-search" value={this.state.keyword} onChange={this.handleChange} />
                <div className="rolling">
                  <ul className="list">
                    <li><button type="button" className="word">머니마켓펀드(MMF)</button></li>
                    <li><button type="button" className="word">뮤추얼펀드</button></li>
                    <li><button type="button" className="word">방카슈랑스</button></li>
                    <li><button type="button" className="word">디플레이션</button></li>
                    <li><button type="button" className="word">헤지펀드</button></li>

                    <li><button className="word">머니마켓펀드(MMF)</button></li>
                  </ul>
                </div>
              </div>
              <></>
              <button className="search-input__del" type="button" title="내용 삭제"> </button>

              <script>

              </script>
            </form>
          </div>
        </div>
        <div className="search-sort">
          <ul className="tab-box">
            <li><button data-tab="sort-1" className="tab-link active">초성</button></li>
            <li><button data-tab="sort-2" className="tab-link">알파벳</button></li>
            <li><button data-tab="sort-3" className="tab-link">숫자</button></li>
          </ul>
          <ul className="sort-list">
            <li><button className="btn" title="ㄱ" data-item="ㄱ" type="button">ㄱ</button></li>
            <li><button className="btn" title="ㄴ" data-item="ㄴ" type="button">ㄴ</button></li>
            <li><button className="btn" title="ㄷ" data-item="ㄷ" type="button">ㄷ</button></li>
            <li><button className="btn" title="ㄹ" data-item="ㄹ" type="button">ㄹ</button></li>
            <li><button className="btn" title="ㅁ" data-item="ㅁ" type="button">ㅁ</button></li>
            <li><button className="btn" title="ㅂ" data-item="ㅂ" type="button">ㅂ</button></li>
            <li><button className="btn" title="ㅅ" data-item="ㅅ" type="button">ㅅ</button></li>
            <li><button className="btn" title="ㅇ" data-item="ㅇ" type="button">ㅇ</button></li>
            <li><button className="btn" title="ㅈ" data-item="ㅈ" type="button">ㅈ</button></li>
            <li><button className="btn" title="ㅊ" data-item="ㅊ" type="button">ㅊ</button></li>
            <li><button className="btn" title="ㅋ" data-item="ㅋ" type="button">ㅋ</button></li>
            <li><button className="btn" title="ㅌ" data-item="ㅌ" type="button">ㅌ</button></li>
            <li><button className="btn" title="ㅍ" data-item="ㅍ" type="button">ㅍ</button></li>
            <li><button className="btn" title="ㅎ" data-item="ㅎ" type="button">ㅎ</button></li>
            <li><button className="btn" title="ㄲ" data-item="ㄲ" type="button">ㄲ</button></li>
            <li><button className="btn" title="ㄸ" data-item="ㄸ" type="button">ㄸ</button></li>
            <li><button className="btn" title="ㅃ" data-item="ㅃ" type="button">ㅃ</button></li>
            <li><button className="btn" title="ㅆ" data-item="ㅆ" type="button">ㅆ</button></li>
            <li><button className="btn" title="ㅉ" data-item="ㅉ" type="button">ㅉ</button></li>
          </ul>
        </div>
      </section>
    );
  }
}

export default SecSearch;          